import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, ChevronRightIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white relative overflow-hidden" data-id="element-95">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-gray-800 to-transparent" data-id="element-96"></div>
      <div className="absolute top-40 left-10 w-72 h-72 bg-amber-400/5 rounded-full blur-3xl" data-id="element-97"></div>
      <div className="absolute bottom-40 right-10 w-96 h-96 bg-red-400/5 rounded-full blur-3xl" data-id="element-98"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10" data-id="element-99">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-100">
          <div className="col-span-1 md:col-span-1" data-id="element-101">
            <div className="flex items-center mb-6" data-id="element-102">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gYt3ksEJhJywGjv4NxKduQ/image.png" alt="Otterreach logo" className="h-12 w-auto mr-3" data-id="element-103" />
              <span className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-red-400" data-id="element-104">
                Otterreach
              </span>
            </div>
            <p className="text-gray-400 mb-8 leading-relaxed" data-id="element-105">
              Transforming prospects into loyal customers through strategic lead
              generation and conversion optimization.
            </p>
            <div className="flex space-x-5" data-id="element-106">
              {['facebook', 'twitter', 'linkedin'].map(social => <a key={social} href="#" className="text-gray-400 hover:text-amber-400 transition-colors bg-white/5 p-3 rounded-full hover:bg-white/10" aria-label={`Follow us on ${social}`} data-id="element-107">
                  <span className="sr-only" data-id="element-108">{social}</span>
                  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-109">
                    {social === 'facebook' && <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-110" />}
                    {social === 'twitter' && <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-111" />}
                    {social === 'linkedin' && <path fillRule="evenodd" d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" clipRule="evenodd" data-id="element-112" />}
                  </svg>
                </a>)}
            </div>
          </div>
          <div data-id="element-113">
            <h3 className="text-lg font-semibold mb-6 text-white" data-id="element-114">
              Quick Links
            </h3>
            <ul className="space-y-4" data-id="element-115">
              {['Services', 'About Us', 'Our Process', 'Testimonials', 'Contact Us'].map(item => <li key={item} data-id="element-116">
                  <a href={`#${item.toLowerCase().replace(' ', '-')}`} className="text-gray-400 hover:text-amber-400 transition-colors flex items-center group" data-id="element-117">
                    <ChevronRightIcon className="h-4 w-4 mr-2 text-amber-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-118" />
                    <span data-id="element-119">{item}</span>
                  </a>
                </li>)}
            </ul>
          </div>
          <div data-id="element-120">
            <h3 className="text-lg font-semibold mb-6 text-white" data-id="element-121">Services</h3>
            <ul className="space-y-4" data-id="element-122">
              {['B2B Lead Generation', 'Email Marketing', 'Content Marketing', 'Social Media', 'SEO Optimization'].map(item => <li key={item} data-id="element-123">
                  <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors flex items-center group" data-id="element-124">
                    <ChevronRightIcon className="h-4 w-4 mr-2 text-amber-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-125" />
                    <span data-id="element-126">{item}</span>
                  </a>
                </li>)}
            </ul>
          </div>
          <div data-id="element-127">
            <h3 className="text-lg font-semibold mb-6 text-white" data-id="element-128">
              Contact Us
            </h3>
            <ul className="space-y-6" data-id="element-129">
              <li className="flex items-center group" data-id="element-130">
                <div className="bg-white/5 p-3 rounded-full mr-4 group-hover:bg-amber-400/10 transition-colors" data-id="element-131">
                  <PhoneIcon className="h-5 w-5 text-amber-400" data-id="element-132" />
                </div>
                <span className="text-gray-300 group-hover:text-amber-300 transition-colors" data-id="element-133">
                  +1 (555) 123-4567
                </span>
              </li>
              <li className="flex items-center group" data-id="element-134">
                <div className="bg-white/5 p-3 rounded-full mr-4 group-hover:bg-amber-400/10 transition-colors" data-id="element-135">
                  <MailIcon className="h-5 w-5 text-amber-400" data-id="element-136" />
                </div>
                <span className="text-gray-300 group-hover:text-amber-300 transition-colors" data-id="element-137">
                  info@otterreach.co
                </span>
              </li>
              <li className="flex items-start group" data-id="element-138">
                <div className="bg-white/5 p-3 rounded-full mr-4 mt-1 group-hover:bg-amber-400/10 transition-colors" data-id="element-139">
                  <MapPinIcon className="h-5 w-5 text-amber-400" data-id="element-140" />
                </div>
                <span className="text-gray-300 group-hover:text-amber-300 transition-colors" data-id="element-141">
                  123 Business Ave, Suite 200
                  <br data-id="element-142" />
                  New York, NY 10001
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-16 pt-10 flex flex-col md:flex-row justify-between items-center" data-id="element-143">
          <p className="text-gray-400" data-id="element-144">
            &copy; {new Date().getFullYear()} Otterreach.co. All rights
            reserved.
          </p>
          <div className="mt-6 md:mt-0 flex flex-wrap gap-6" data-id="element-145">
            {['Privacy Policy', 'Terms of Service', 'Cookie Policy'].map(item => <a key={item} href="#" className="text-gray-400 hover:text-amber-400 transition-colors" data-id="element-146">
                  {item}
                </a>)}
          </div>
        </div>
      </div>
    </footer>;
}